/**
 * @module interface
 */

export interface V2TimMessageExtension {
    extensionKey: string;
    extensionValue: string;
}
